<template>
  <div :class="['instagram-feed', 'instagram-feed--' + mode, { 'instagram-feed--error': error }]">
    <div
      v-if="!isLoading"
      class="instagram-feed__medias">
      <div
        v-for="(media, index) in medias"
        :class="['instagram-feed__media', {'instagram-feed__media--active': mode == 'slider' && sliderIndex == index}]">
        <div
          v-if="mode == 'slider'"
          :style="{ 'background-image': 'url(' + media.images[mediaResolution].url + ')' }"
          class="instagram-feed__blur">
        </div>

        <div
          v-if="media.type == 'image' || mode !== 'slider'"
          class="instagram-feed__image"
          :style="{ 'background-image': 'url(' + media.images[mediaResolution].url + ')' }">
        </div>

        <video
          v-if="media.type == 'video' && mode === 'slider'"
          class="instagram-feed__video"
          :poster="media.images.standard_resolution.url"
          autoplay
          muted
          onloadedmetadata="this.muted = true"
          loop>
          <source :src="media.videos.low_resolution.url" type="video/mp4">
          Your browser does not support the video tag.
        </video>

        <a
          v-if="mode !== 'slider'"
          :href="media.link"
          target="_blank">
        </a>
      </div>

      <div v-if="mode !== 'slider' && loadMoreEnable" class="load-more">
        <button
          @click="loadMoreMedias"
          class="load-more-button">
          {{ $t("instagramFeedLoadMore", lang) }}
        </button>
      </div>
    </div>

    <spinner v-if="isLoading && !error"></spinner>

    <div
      v-if="error"
      class="instagram-feed__error-message">
      {{ $t("instagramFeedError", lang) }}
    </div>

    <template v-if="mode == 'slider' && !isLoading">
      <div @click="previousMedia" class="instagram-feed__arrow instagram-feed__arrow--left"></div>
      <div @click="nextMedia" class="instagram-feed__arrow instagram-feed__arrow--right"></div>

      <!-- <div class="instagram-feed__thumbnails">
        <span
          v-for="(media, index) in images"
          @click="sliderIndex = index"
          :class="[{'selected': sliderIndex == index}]">
        </span>
      </div> -->
    </template>
  </div>
</template>

<script>
import Spinner from './Spinner.vue';
import Hammer from "hammerjs";
import jsonp from "jsonp";

export default {
  name: "instagram-feed",

  components: { Spinner },

  props: {
    lang: { type: String, required: true }, // Lang binded from parent.
    userId: { type: String, required: true }, // Instagram ID of the feed where we fetch images.
    accessToken: { type: String, required: true }, // Instagram access token.
    mediaCount: { type: Number, required: true}, // Maximum number of displayed pictures.
    mode: { type: String, required: true } // slider, list
  },

  data () {
    return {
      isLoading: true,
      error: false,
      loadMoreEnable: true,
      medias: {},
      sliderIndex: 0,
      nextMaxId: ""
    }
  },

  computed: {
    mediaResolution() {
      return (this.mode === "slider") ? "standard_resolution" : "thumbnail";
    }
  },

  created() {
    this.hammer = null;
    this.getMediasByUser(this.userId, this.mediaCount);
  },

  methods: {
    getMediasByUser(userId, count) {
      var endpoint = `https://api.instagram.com/v1/users/${userId}/media/recent/?access_token=${this.accessToken}&count=${count}`;

      jsonp(endpoint, null, (error, response) => {
        if (error) {
          this.error = true;
        }
        else {
          if (response.data.length == 0 || response.meta.code !== 200) {
            this.error = true;
            return;
          }

          this.isLoading = false;
          this.medias = response.data;
          this.nextMaxId = response.pagination.next_max_id;

          if (this.mode === "slider") {
            setTimeout(() => { this.bindSliderGestures(); }, 300); // Quick fix to bind gestures only when the dom is rendered.
          }
        }
      });
    },

    loadMoreMedias(event) {
      var endpoint = `https://api.instagram.com/v1/users/${this.userId}/media/recent/?access_token=${this.accessToken}&count=${this.mediaCount}`;
      event.target.disabled = true;

      if (this.nextMaxId) {
        endpoint += `&max_id=${this.nextMaxId}`;
      }

      jsonp(endpoint, null, (error, response) => {
        if (error) {
          this.loadMoreEnable = false;
        }
        else {
          this.nextMaxId = response.pagination.next_max_id;
          this.medias = this.medias.concat(response.data);

          event.target.disabled = false;

          if (response.data.length < this.mediaCount) {
            this.loadMoreEnable = false;
          }
        }
      });
    },

    previousMedia() {
      this.sliderIndex = (this.sliderIndex == 0) ? this.medias.length - 1 : this.sliderIndex -= 1;
    },

    nextMedia() {
      this.sliderIndex = (this.sliderIndex == this.medias.length - 1) ? 0 : this.sliderIndex += 1;
    },

    bindSliderGestures() {
      var direction = "";

      this.hammer = new Hammer(this.$el.children[0]);

      this.hammer.on("panleft panright", event => {
        direction = event.type;
      });

      this.hammer.on("panend", event => {
        var swipe_angle = Math.abs(event.angle);

        if (swipe_angle >= 90 && swipe_angle < 130)
          return;

        if (swipe_angle > 50 && swipe_angle < 90)
          return;

        if (direction === "panleft") {
          this.nextMedia();
        }
        else if (direction === "panright") {
          this.previousMedia();
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// InstagramFeed.vue?67271dde